import type React from "react";
import { ReactComponent as Svg } from "./assets/esic2.svg";
import * as styles from "./Icon.module.scss";

type Esic2Props = React.SVGProps<SVGSVGElement>;

export const Esic2 = ({ className, ...props }: Esic2Props) => (
  <Svg className={className ?? styles.base} {...props} />
);
